var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116,
    height: 170,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_svg__a)",
    d: "M96.254 78a6.75 6.75 0 0 1 6.214 9.363l-30.83 73.566A14.79 14.79 0 0 1 58 169.999a14.79 14.79 0 0 1-13.638-9.07l-30.83-73.566A6.75 6.75 0 0 1 19.746 78z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_svg__b)",
    d: "M113.081 74.989A56.2 56.2 0 0 0 116 56.5C115.686 25.458 89.628.042 58.084 0 26.011-.043 0 25.529 0 57.079a56.1 56.1 0 0 0 2.817 17.6 28.16 28.16 0 0 0 18.892 18.052 127.73 127.73 0 0 0 73.02-.129 27.73 27.73 0 0 0 18.352-17.613"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_svg__a",
    x1: 58,
    x2: 58,
    y1: 95.848,
    y2: 167.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#027CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#218CBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#48A0C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    stopColor: "#61ADCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AB2D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_svg__b",
    x1: 50.809,
    x2: 62.805,
    y1: 98.192,
    y2: 2.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#027CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgIcon;